import { useState, useEffect } from 'react';

const COOKIE_CONSENT_KEY = 'fastrack_cookie_consent';

interface CookieConsentData {
    accepted: boolean;
    acceptedAt: string;
    userAgent: string;
    version: string;
}

interface UseCookieConsentResult {
    hasConsentedToCookies: boolean;
    acceptCookieConsent: () => void;
    isLoading: boolean;
}

export const useCookieConsent = (): UseCookieConsentResult => {
    const [hasConsentedToCookies, setHasConsentedToCookies] = useState<boolean>(true);
    const [isLoading, setIsLoading] = useState<boolean>(true);

    useEffect(() => {
        const checkCookieConsent = (): void => {
            const consentData = localStorage.getItem(COOKIE_CONSENT_KEY);
            if (consentData) {
                setHasConsentedToCookies(true);
            } else {
                setHasConsentedToCookies(false);
            }
            setIsLoading(false);
        };

        checkCookieConsent();
    }, []);

    const acceptCookieConsent = (): void => {
        const consentData: CookieConsentData = {
            accepted: true,
            acceptedAt: new Date().toISOString(),
            userAgent: navigator.userAgent,
            version: '1.0'
        };
        localStorage.setItem(COOKIE_CONSENT_KEY, JSON.stringify(consentData));
        setHasConsentedToCookies(true);
    };

    return {
        hasConsentedToCookies,
        acceptCookieConsent,
        isLoading
    };
};

export default useCookieConsent;
